
/**
 * consider consolidating these and making the variations into attributes
 * eg View Program, layout:Builder, programs:14, sessions:30, performers:18, etc...
 */

export type TraceNameType = "User Login" // these have to be under 33 characters long
| "View Attendees"
| "View Attendee Sessions"
| "View Attendee Configure"
| "Create User"
| "View Home"
| "View Notification Settings"
| "View Accounts"
| "View Account"
| "View Event" 
| "View Engage Tasks"
| "View Engage Workforce"
| "View Engage Notices"
| "View Program Builder" 
| "View Program Timeline"
| "View Program Logistics"
| "View Program Summary"
| "View Program Publish"
| "Create Program Publish"
| "Action Program Publish"
| "View Event Information"
| "View On Site Schedule Date"
| "View On Site Schedule Build"
| "View On Site Schedule Timeline"
| "View On Site Schedule Share"
| "View Tasks Table"
| "View Tasks List"
| "View Tasks Calendar"
| "View Tasks Time"
| "View Workforce Table"
| "View Facilitator Notes"
| "View Sponsors"
| "View Sponsor Sessions"
| "View Performers"
| "View Sessions"
| "View Performer Information"
| "View Performer Brief"
| "View My Schedule"
| "View My Tasks Table"
| "View My Tasks List"
| "View My Tasks Calendar"
| "View My Tasks Time"
| "Action Workforce"
| "View Exhibitors"
| "View Exhibitor Stands"
| "View Exhibitor Information"
| "View Exhibitor Brief"
| "View Event Lists"
| "View All Tasks"
| "View Clipboard"
| "View Budget Revenue"
| "View Budget Costs"
| "View Budget Admin"
| "View Budget Report"
| "View Budget Quotes"
| "View Assets Table"
| "View Home Budget"
| "View Resources"
| "View Resource Information"
| "View Performer Answers"
| "View Resource Answers"
| "View Sponsor Answers"
| "View Exhibitor Answers"
| "View Submitted Performers"
| "View Submitted Resources"
| "View Program Table"
| "View Backups"
| "View Submitted Exhibitors"
| "View Submitted Attendeees"
| "View Share Branding"
| "View Event Apps"
| "View Logistics Share"
| "View Logistics Views"
| "View Logistics Build"
| "View Cue Sheets"
| 'View Attendee Answers'


export const traceNames: { [key: string]: TraceNameType } = {
  userLogin: "User Login"
  ,viewAttendees: "View Attendees"
  ,viewAttendeSessions: "View Attendee Sessions"
  ,viewAttendeeConfigure: "View Attendee Configure"
  ,viewSubmittedAttendees: "View Submitted Attendeees"
  ,viewCueSheets: "View Cue Sheets"
  ,viewLogisticsShare: "View Logistics Share"
  ,viewLogisticsViews: "View Logistics Views"
  ,viewLogisticsBuild: "View Logistics Build"
  ,viewEventApps: "View Event Apps"
  ,viewShareBranding: "View Share Branding"
  ,viewBackups: "View Backups"
  ,viewProgramTable: "View Program Table"
  ,viewSubmittedPerformers: "View Submitted Performers"
  ,viewSubmittedResources: "View Submitted Resources"
  ,viewSubmittedExhibitors: "View Submitted Exhibitors"
  ,viewSponsorAnswers: 'View Sponsor Answers'
  ,viewPerformerAnswers: 'View Performer Answers'
  ,viewResourceAnswers: 'View Resource Answers'
  ,viewExhibitorAnswers: 'View Exhibitor Answers'
  ,viewAttendeeAnswers: 'View Attendee Answers'
  ,createUser: "Create User"
  ,viewHome: "View Home"
  ,viewNotificationSettings: "View Notification Settings"
  ,viewAccounts: "View Accounts"
  ,viewAccount: "View Account"
  ,viewAssetsTable: "View Assets Table"
  ,viewEvent: "View Event" 
  ,viewEngageTasks: "View Engage Tasks"
  ,viewEngageWorkforce: "View Engage Workforce"
  ,viewEngageNotices: "View Engage Notices"
  ,viewProgramBuilder: "View Program Builder" 
  ,viewProgramTimeline: "View Program Timeline"
  ,viewProgramLogistics: "View Program Logistics"
  ,viewProgramItinerary: "View Program Summary"
  ,viewProgramPublish: "View Program Publish"
  ,createProgramPublish: "Create Program Publish"
  ,actionProgramPublish: "Action Program Publish"
  ,viewProgramInformation: "View Event Information"
  ,viewOnSiteScheduleDate: "View On Site Schedule Date"
  ,viewOnSiteScheduleBuilder: "View On Site Schedule Build"
  ,viewOnSiteScheduleTimeline: "View On Site Schedule Timeline"
  ,viewOnSiteScheduleShare: "View On Site Schedule Share"
  ,viewTasksTable: "View Tasks Table"
  ,viewTasksList: "View Tasks List"
  ,viewTasksCalendar: "View Tasks Calendar"
  ,viewTasksTime: "View Tasks Time"
  ,viewWorkforceTable: "View Workforce Table"
  ,viewFacilitatorNotes: "View Facilitator Notes"
  ,viewPerformers: "View Performers"
  ,viewSessions: "View Sessions"
  ,viewPerformerInformation: "View Performer Information"
  ,viewPerformerBrief: "View Performer Brief"
  ,viewSponsors: "View Sponsors"
  ,viewSponsorSessions: "View Sponsor Sessions"
  ,viewMySchedule: "View My Schedule"
  ,viewMyTasksTable: "View My Tasks Table"
  ,viewMyTasksList: "View My Tasks List"
  ,viewMyTasksCalendar: "View My Tasks Calendar"
  ,viewMyTasksTime: "View My Tasks Time"
  ,actionWorkforce: "Action Workforce"
  ,viewExhibitors:  "View Exhibitors"
  ,viewExhibitorInformation: "View Exhibitor Information"
  ,viewExhibitorStands: "View Exhibitor Stands"
  ,viewExhibitorBrief: "View Exhibitor Brief"
  ,viewEventLists: "View Event Lists"
  ,viewAllTasks: "View All Tasks"
  ,viewClipboard: "View Clipboard"
  ,viewBudgetRevenue: "View Budget Revenue"
  ,viewBudgetCosts: "View Budget Costs"
  ,viewBudgetAdmin: "View Budget Admin"
  ,viewBudgetReport: "View Budget Report"
  ,viewBudgetQuotes: "View Budget Quotes"
  ,viewHomeBudget: "View Home Budget"
  ,viewResources: "View Resources"
  ,viewResourceInformation: "View Resource Information"
} as const


export const engageRouteToTraceName = {
  tasks: "View Engage Tasks",
  workforce: "View Engage Workforce",
  notices: "View Engage Notices",
}

export interface TraceStopOptions {
  attributes?:{name:string, value:any}[]
  metrics?:{name:string, value:any}[]
  increments?:string[]
}